import { combineEpics } from "redux-observable";
import { epicExpansionBuyPremium } from "./epicExpansionBuyPremium";
import { epicExpansionBuyPremiumPurchase } from "./epicExpansionBuyPremiumPurchase";
import { epicExpansionsBuyStandardPurchase } from "./epicExpansionsBuyStandardPurchase";
import { epicExpansionsSelect } from "./epicExpansionsSelect";
export var epicExpansions = combineEpics(epicExpansionsSelect, epicExpansionsBuyStandardPurchase, epicExpansionBuyPremium, epicExpansionBuyPremiumPurchase);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/epics/epicExpansions.ts
// module id = 2094
// module chunks = 3